module.exports = __webpack_public_path__ + "static/media/AMR_SALUD.b6d21579.png";